import { render } from "./UserView.vue?vue&type=template&id=8c5fd58a"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=8c5fd58a&lang=scss"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__